const AccessControlPill = ({data, lang}) => {
  // can rename to Private Access. Standard can become Open Access
     return (
     <div 
      className={`w-full px-2 mx-auto whitespace-nowrap text-center mt-auto text-xs py-1 border-2 rounded-3xl max-w-36 
      ${data.talent_access_control.talent_access_level === 'PRIVATE' ? 'border-amber-500' : data.talent_access_control.talent_access_level ==='STANDARD' ? 'border-indigo-500' : 'border-green-500'}`}>
          {
            data.talent_access_control.talent_access_level === 'PRIVATE' ? 
            <span className="text-amber-600 dark:text-amber-500">
              <i className="mr-1 fa-solid fa-lock text-amber-500 text-base"/>
              {lang === 'fr' ? 'Accès Confidentiel' : 'Private Access'}
            </span> 
            : 
            data.talent_access_control.talent_access_level === 'STANDARD' ? 
            <span className="text-indigo-600 dark:text-indigo-500">
              <i className="mr-1 fa-solid fa-unlock text-indigo-500 text-base"/>
              {lang === 'fr' ? 'Accès Standard' : 'Standard Access'}
            </span> 
            :
            <span className="text-green-700 dark:text-green-500"><i className="mr-1 fa-solid fa-lock-open text-green-500 text-base"></i>
              {lang === 'fr' ? 'Accès Public' : 'Public Access'}
            </span>
            }
          </div>)
}

export default AccessControlPill